import { QuestionBase } from './question-base';

export class PercentQuestion extends QuestionBase<number> {
  controlType = 'percentage';
}
